module.exports = global["PIXI"] = require("-!./pixi.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser/build/custom/pixi.js
// module id = 2
// module chunks = 0